import { ProductInfo, PredefinedConfiguration, CoverItem } from 'sofa-reborn-react';

import { setArmrests } from '../../armrest';
import { AppDispatch } from '../..';

import { ProductData, Product } from '@ikea-aoa/component-view-3d';

export default class AssignUtil {
	public static localIds(products: ProductData, productInfo: ProductInfo): void {
		Object.entries(products).forEach(([key, product]) => {
			const { productId, sprItems } = product as Product;
			/* Add local id to all spr items */
			if (sprItems) {
				sprItems.forEach((sprItem) => {
					const sprItemInfo = productInfo[sprItem.itemno];
					if (sprItemInfo && sprItemInfo.content) {
						sprItem['localId'] = sprItemInfo.content.itemNoLocal || '';
					}
				});
			}
			const productInfoItem = productInfo[productId];
			if (productInfoItem && productInfoItem.content) {
				products[key]['localId'] = productInfoItem.content.itemNoLocal || '';
			}
		});
	}

	public static images(products: ProductData, productInfo: ProductInfo): void {
		Object.entries(products).forEach(([key, product]) => {
			const { productId } = product as Product;
			const productInfoItem = productInfo[productId];
			if (productInfoItem && productInfoItem.content && productInfoItem.content.image) {
				const images = productInfoItem.content.image
					.filter((mediaItem) => mediaItem.size === 'S5')
					.map((imageItem) => {
						return {
							src: imageItem.url,
							alt: imageItem.typeName,
							productImage: true,
							typeName: imageItem.typeName,
						};
					});
				products[key]['images'] = images;
			}
		});
	}

	public static localIdsToPredefinedConfigurations(
		predefinedConfigurations: PredefinedConfiguration[],
		productInfo: ProductInfo
	): void {
		predefinedConfigurations.forEach((configuration, index) => {
			const configurationId = configuration.id;
			if (configurationId && productInfo[configurationId]) {
				const productContent = productInfo[configurationId].content;
				if (productContent) {
					predefinedConfigurations[index]['localId'] = productContent.itemNoLocal || '';
				}
			}
			const coverConfigurationId = configuration.coverId;
			if (coverConfigurationId && productInfo[coverConfigurationId]) {
				const productContent = productInfo[coverConfigurationId].content;
				if (productContent) {
					predefinedConfigurations[index]['coverId'] =
						productContent.itemNoGlobal || productContent.itemNoLocal || '';
				}
			}
		});
	}

	public static armrests(dispatch: AppDispatch, products: ProductData, covers: CoverItem[]): void {
		const armrests = {};
		let hasBothWideAndRegularArmrest = false;
		covers.forEach((cover) => {
			const regularArmrest = Object.values(products).find(
				(product: Product) =>
					product.modelId === 'VIMLE_FRM_ARMREST' && product.filter.color === cover.coverName
			);
			const wideArmrest = Object.values(products).find(
				(product: Product) =>
					product.modelId === 'VIMLE_FRM_WIDE_ARMREST' && product.filter.color === cover.coverName
			);
			if (regularArmrest && wideArmrest) {
				hasBothWideAndRegularArmrest = true;
			}
			if (regularArmrest || wideArmrest) {
				armrests[cover.coverName] = { regularArmrest, wideArmrest };
			}
		});

		if (Object.keys(armrests).length && hasBothWideAndRegularArmrest) {
			dispatch(setArmrests(armrests));
		}
	}
}
